import moment from "moment";

export default class EventWaitingListEntry {
    static STATUS_WAITING = 'waiting';
    static STATUS_AVAILABLE = 'available';
    static STATUS_EXPIRED = 'expired';
    static STATUS_REGISTERED = 'registered';

    id;
    event;
    period;
    period_title;
    position;
    email;
    client;
    attendee;
    status;
    created_at;
    notified_at;
    expires_at;
    registered_at;

    static fromJson = (json) => {
        let item = new EventWaitingListEntry();

        item.id = json.id;
        item.event = json.event;
        item.period = json.period;
        item.period_title = json.period_title;
        item.position = json.position;
        item.email = json.email;
        item.client = json.client;
        item.attendee = json.attendee;
        item.status = json.status;
        item.created_at = json.created_at ? moment(json.created_at) : null;
        item.notified_at = json.notified_at ? moment(json.notified_at) : null;
        item.expires_at = json.expires_at ? moment(json.expires_at) : null;
        item.registered_at = json.registered_at ? moment(json.registered_at) : null;

        return item;
    }

    statusVariant = () => {
        switch (this.status) {
            case EventWaitingListEntry.STATUS_AVAILABLE:
                return 'success';
            case EventWaitingListEntry.STATUS_REGISTERED:
                return 'primary';
            case EventWaitingListEntry.STATUS_EXPIRED:
                return 'secondary';
            case EventWaitingListEntry.STATUS_WAITING:
            default:
                return 'warning';
        }
    }
}
